import styled from "@emotion/styled";
import React from "react";

const UserMessage = ({ text }) => {
  return <StyledUserMessage>{text}</StyledUserMessage>;
};

const StyledUserMessage = styled.p`
  display: flex;
  background: ${(props) => props.theme.colors.primary};
  color: white;
  font-size: 14px;
  padding: 12px 20px;
  border-radius: 24px 24px 4px 24px;
  align-self: flex-end;
  line-height: 18px;
  max-width: 203px;
`;
export default UserMessage;
